<script lang="ts">
  // component
  import Banner from "@retailer/svelte/Payments/Banners/Base.svelte";

  // props
  export let handleBannerClose: (type: string) => {};

  // data
  const creditsBannerType = "credits_banner";

</script>

<div class="fizz-flex-item fizz-inset-square-16" data-testid={creditsBannerType}>
  <Banner
    iconType={"Coin"}
    heading="Introducing Credits on ProviPay!"
    onClose={() => handleBannerClose(creditsBannerType)}
    height={90}
    width={90}
    color={"green"}
  >
    <p class="fizz-text-medium">
      You can now easily apply distributor credits to your outstanding invoices, or set them up to
      automatically apply through AutoPay.
    </p>
  </Banner>
</div>
